import { render, staticRenderFns } from "./QandABlock.vue?vue&type=template&id=3cc9a103"
import script from "./QandABlock.vue?vue&type=script&lang=js"
export * from "./QandABlock.vue?vue&type=script&lang=js"
import style0 from "./QandABlock.vue?vue&type=style&index=0&id=3cc9a103&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc9a103')) {
      api.createRecord('3cc9a103', component.options)
    } else {
      api.reload('3cc9a103', component.options)
    }
    module.hot.accept("./QandABlock.vue?vue&type=template&id=3cc9a103", function () {
      api.rerender('3cc9a103', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invention/QandABlock.vue"
export default component.exports